import BluemoonFieldsMappingContainer from "./BluemoonFieldsMappingContainer";

export default BluemoonFieldsMappingContainer;
